import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=5b8f3c18&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=5b8f3c18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f3c18",
  null
  
)

export default component.exports